import { friendApplicationListQueryOptions } from '@/hooks/users/use-friend-applications';
import { catchFetcherError } from '@/utils/fetcher';
import { queryClient } from '@/utils/query-client';

export function friendApplicationsLoader() {
  return {
    promises: queryClient.ensureQueryData(friendApplicationListQueryOptions).catch(catchFetcherError),
  };
}
